module.exports = __webpack_public_path__ + "bi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bi.svg
// module id = 449
// module chunks = 0